// import React from 'react';
// import './Payslip.css'; // Import the CSS file for styles

const Payslip = ({ payslip, user, earnings, deductions }) => {
  console.log("helllo nnfkenfklje");
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("default", { month: "long", year: "numeric" });
  };

  const formatJoiningDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const moneyFormatIndia = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount);
  };

  const convertMoneyWord = (amount) => {
    // Implement your logic to convert number to words
    // This is a placeholder function
    return amount.toString(); // Replace with actual conversion logic
  };

  const monthname = formatDate(payslip.sdate);
  const joiningdate = formatJoiningDate(user.join_date);
  const otherAllowanceJson = JSON.parse(payslip.other_allowance_json);
  const otherDeductionJson = JSON.parse(payslip.other_deduction_json);

  return (
    <div>
      <table style={{ width: "100%", margin: "0 auto" }}>
        <tbody>
          <tr>
            <td style={{ textAlign: "left" }}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/logonew.png`}
                alt=""
                style={{ width: "150px" }}
              />
              <h3>STREETGAINS TECHNOLOGIES PVT LTD</h3>
              <div style={{ lineHeight: "16px" }}>
                No.2, 4th Main, HBCS Stage II, <br />
                Chandra Layout, Bangalore- 560040
              </div>
            </td>
            <td style={{ textAlign: "right" }}>
              <div style={{ marginTop: "50px" }}>
                <h1>PAY SLIP</h1>
                <h3>{monthname}</h3>
                <h3>{user.user_fullname}</h3>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table className="bordered">
        <tbody>
          <tr>
            <td style={{ width: "20%" }}>Employee Number</td>
            <td style={{ width: "30%" }}>: {user.user_code}</td>
            <td style={{ width: "25%" }}>Tax Regime</td>
            <td style={{ width: "25%" }}>: Regular Tax Regime</td>
          </tr>
          <tr>
            <td>Designation</td>
            <td>: {user.user_designation}</td>
            <td>Income Tax Number (PAN)</td>
            <td>: {user.user_pan}</td>
          </tr>
          <tr>
            <td>Location</td>
            <td>: Bangalore</td>
            <td>PF account number</td>
            <td>:</td>
          </tr>
          <tr>
            <td>Bank Details</td>
            <td>: {user.bank_account}</td>
            <td>ESI Number</td>
            <td>: {user.esinumber}</td>
          </tr>
          <tr>
            <td>Date of joining</td>
            <td>: {joiningdate}</td>
            <td>Universal Account Number (UAN)</td>
            <td>:</td>
          </tr>
        </tbody>
      </table>
      <table
        className="bordered"
        style={{ marginTop: "15px", marginBottom: "15px" }}
      >
        <tbody>
          <tr>
            <td style={{ width: "20%" }}>Working Days</td>
            <td style={{ width: "30%" }}>: {payslip.total_days} Days</td>
            <td style={{ width: "25%" }}>Attendance Days</td>
            <td style={{ width: "25%" }}>: {payslip.working_days} Days</td>
          </tr>
        </tbody>
      </table>
      <table className="bordered">
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top", width: "50%" }}>
              <table>
                <tbody>
                  <tr className="bg-color">
                    <td>Earnings</td>
                    <td className="text-right">Amount</td>
                  </tr>
                  {earnings.map((value, index) => (
                    <tr key={index}>
                      <td>{value.title}</td>
                      <td className="text-right">
                        {moneyFormatIndia(value.value)}
                      </td>
                    </tr>
                  ))}
                  {otherAllowanceJson.map((value, index) => (
                    <tr key={index}>
                      <td>{value.title}</td>
                      <td className="text-right">
                        {moneyFormatIndia(value.amount)}
                      </td>
                    </tr>
                  ))}
                  {payslip.earned_incentive > 0 && (
                    <tr>
                      <td>Incentive</td>
                      <td className="text-right">
                        {moneyFormatIndia(payslip.earned_incentive)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
            <td style={{ verticalAlign: "top", width: "50%" }}>
              <table>
                <tbody>
                  <tr className="bg-color">
                    <td>Deductions</td>
                    <td className="text-right">Amount</td>
                  </tr>
                  {deductions.map((value, index) => (
                    <tr key={index}>
                      <td>{value.title}</td>
                      <td className="text-right">
                        {moneyFormatIndia(value.value)}
                      </td>
                    </tr>
                  ))}
                  {otherDeductionJson.map((value, index) => (
                    <tr key={index}>
                      <td>{value.title}</td>
                      <td className="text-right">
                        {moneyFormatIndia(value.amount)}
                      </td>
                    </tr>
                  ))}
                  {payslip.pt > 0 && (
                    <tr>
                      <td>PT</td>
                      <td className="text-right">
                        {moneyFormatIndia(payslip.pt)}
                      </td>
                    </tr>
                  )}
                  {payslip.esic > 0 && (
                    <tr>
                      <td>ESIC</td>
                      <td className="text-right">
                        {moneyFormatIndia(payslip.esic)}
                      </td>
                    </tr>
                  )}
                  {payslip.tds > 0 && (
                    <tr>
                      <td>TDS</td>
                      <td className="text-right">
                        {moneyFormatIndia(payslip.tds)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              {payslip.total_allowance > 0 && (
                <span style={{ paddingLeft: "10px" }}>Total Allowance</span>
              )}
              {payslip.total_allowance > 0 && (
                <span
                  style={{
                    float: "right",
                    textAlign: "right",
                    paddingRight: "10px",
                  }}
                >
                  {moneyFormatIndia(payslip.total_allowance)}
                </span>
              )}
            </td>
            <td>
              {payslip.total_deduction > 0 && (
                <span style={{ paddingLeft: "10px" }}>Total Deduction</span>
              )}
              {payslip.total_deduction > 0 && (
                <span
                  style={{
                    float: "right",
                    textAlign: "right",
                    paddingRight: "10px",
                  }}
                >
                  {moneyFormatIndia(payslip.total_deduction)}
                </span>
              )}
            </td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>
              {payslip.net_salary > 0 && (
                <span style={{ paddingLeft: "10px" }}>Net Salary</span>
              )}
              {payslip.net_salary > 0 && (
                <span
                  style={{
                    float: "right",
                    textAlign: "right",
                    paddingRight: "10px",
                  }}
                >
                  {moneyFormatIndia(payslip.net_salary)}
                </span>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ marginTop: "25px" }}>
        <tbody>
          <tr>
            <td>
              <b style={{ lineHeight: "24px" }}>Amount (in words):</b> <br />
              INR {convertMoneyWord(payslip.net_salary)}
            </td>
          </tr>
          <tr style={{ textAlign: "center" }}>
            <td>
              This is a computer-generated payslip and does not require a
              signature.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Payslip;
